import React from "react";
import { Link } from "react-router-dom";

const Copy = () => {
  const year = new Date().getFullYear();

  return (
    <div className="__fw">
      <div className="__mw">
        <div className="copy_wrp">
          {/* Section 1: Copyright */}
          <span>Copyright © {year} Intellitech</span>

          {/* Section 2: Policy Links */}
          <div className="tp">
            <Link to="/privacy-policy">
              <span>Privacy Policy</span>
            </Link>
            <Link to="/terms-of-service">
              <span>Terms & Service</span>
            </Link>
          </div>

          {/* Section 3: Attribution */}
          <span className="dev_by">
            Developed by{" "}
            <a
              style={{ color: "white", textDecoration: "none" }}
              href="https://redesigno.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              ReDesigno
            </a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Copy;
